// set up URL link (needs to be HTTPS) - I used ngrok for localhost

//var baseUrl = 'https://sofa.crazybeaver.net/';
var baseUrl = 'https://homefurnitureinternational.com/reviews/public/';

var sort='created_at';
var order='DESC'; 
var stars_filter=0;
var searchQuery = '';
var noReviews = false;

// Star rating

jQuery(':radio').change(function() {
  console.log('New star rating: ' + this.value);
});



jQuery(window).load(function(){

// This is a part of the Pre-order module ;)
  
  jQuery('.shipping-wrapper').css('visibility', 'visible');

});


jQuery(document).ready(function(){
  
  // Delete spaces from price on Product page
  
  var money = jQuery('.current_price .money').html();
  
  if(jQuery('.current_price .money').length)
  	money = money.replace(/\s+/g, '');
 
 
  // External functions

  var a = ['','one ','two ','three ','four ', 'five ','six ','rven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
  var b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];

  function inWords (num) {
      if ((num = num).length > 9) return 'overflow';
      n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
      if (!n) return; var str = '';
      str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
      str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
      str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
      str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
      str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + '  ' : '';
      return str;
  }

  String.prototype.capitalize = function() {
      return this.charAt(0).toUpperCase() + this.slice(1);
  }
  
  
  var productSlug = jQuery('#lbm-reviews').attr('data-slug');

  
  // Search
  
  jQuery('#review-query').on('input', function(e){
    
    searchQuery = jQuery(this).val();
    if (searchQuery.length>0)
      reviews(baseUrl + 'reviews/slug/' + productSlug + '/' + sort + '/' + order + '/' + stars_filter + '/' + searchQuery);
   	else
      reviews(baseUrl + 'reviews/slug/' + productSlug + '/' + sort + '/' + order + '/' + stars_filter);
   
  });
  
  

  // Sort
  
  jQuery('.review-sort').change(function(){
    sort = jQuery(this).val();
    order = jQuery(this).attr('data-order');
  
    if (searchQuery.length>0)
      reviews(baseUrl + 'reviews/slug/' + productSlug + '/'+ sort + '/' + order + '/' + stars_filter + '/' + searchQuery);
 	else
      reviews(baseUrl + 'reviews/slug/' + productSlug + '/'+ sort + '/' + order + '/' + stars_filter);

  });
  
  
  // Stars filter

    jQuery('.stars-filter-select').change(function(){
    stars_filter = jQuery(this).val();
    
   if (searchQuery.length>0)
      reviews(baseUrl + 'reviews/slug/' + productSlug + '/'+ sort + '/' + order + '/' + stars_filter + '/' + searchQuery);
 	else
      reviews(baseUrl + 'reviews/slug/' + productSlug + '/'+ sort + '/' + order + '/' + stars_filter);


  });
  
  
// Load reviews
reviews(baseUrl + 'reviews/slug/' + productSlug);

reviews_summary(baseUrl + 'reviews/summary/slug/' + productSlug);

  
function reviews_summary (url) {
  summary = jQuery('#reviews-summary');
  summary_full = jQuery('.reviews-summary');
  summary.html('');
  summary_full.html('');

  jQuery.get(url, function(data) { 
    
    var s='';
    var rating = Math.round(data.stars);

      stars = '';
    // for (i=0; i < rating; i++) { 
       for (i=0; i < 5; i++) { 
		if (i<rating) 
         stars += '<i class="star"></i>';
        else
		 stars += '<i class="star empty"></i>';

      }
    
    if (data.count>1) s='s';
  
    if (data.count>0) {
      summary.html(
      	stars +  ' <a href="#customer-reviews">' + data.count + ' review' + s + '</a>'
      );

    }
    
    else {
      summary.html('');
      noReviews=true;
      console.log('noRewviews: '+noReviews);
      
      // hide reviews container
      jQuery("#reviews-controls").html("There are no reviews at this time. You can add the first one below.<br/><br/>");
    }
    
    // Full summary
    
    var chart='';
    var stars5_percentage = Math.round(data.stars5/data.count*100);
    var stars4_percentage = Math.round(data.stars4/data.count*100);
    var stars3_percentage = Math.round(data.stars3/data.count*100);
    var stars2_percentage = Math.round(data.stars2/data.count*100);
    var stars1_percentage = Math.round(data.stars1/data.count*100);

   // if (stars5_percentage)
    chart +=  '<a href="#5" class="stars-filter"><div class="stars">5 stars</div>' + '<div class="chart"><div style="width:'+stars5_percentage+'%"></div></div>' + ' ' + stars5_percentage + '%</a>';
    
//    if(stars4_percentage)
    chart += '<a href="#4" class="stars-filter"><div class="stars">4 stars</div>' + '<div class="chart"><div style="width:'+stars4_percentage+'%"></div></div>' + ' ' + stars4_percentage + '%</a>';
    
  //  if(stars3_percentage)
    chart += '<a href="#3" class="stars-filter"><div class="stars">3 stars</div>' + '<div class="chart"><div style="width:'+stars3_percentage+'%"></div></div>' + ' ' + stars3_percentage + '%</a>';
    
  //  if(stars2_percentage)
    chart += '<a href="#2" class="stars-filter"><div class="stars">2 stars</div>' + '<div class="chart"><div style="width:'+stars2_percentage+'%"></div></div>' + ' ' + stars2_percentage + '%</a>';
    
   // if(stars1_percentage)
    chart += '<a href="#1" class="stars-filter"><div class="stars">1 stars</div>' + '<div class="chart"><div style="width:'+stars1_percentage+'%"></div></div>' + ' ' + stars1_percentage + '%</a>';
    
    summary_full.html('<div class="sum">' + stars + '<span>' + data.count + '</span></div> ' + chart);
    
    jQuery('.stars-filter').click(function(){
    stars_filter = jQuery(this).attr('href');
    stars_filter = stars_filter.substring(1, stars_filter.length);
    
    //if (order=='DESC') jQuery(this).attr('data-order', 'ASC');
    //if (order=='ASC') jQuery(this).attr('data-order', 'DESC');
    
   if (searchQuery.length>0)
      reviews(baseUrl + 'reviews/slug/' + productSlug + '/'+ sort + '/' + order + '/' + stars_filter + '/' + searchQuery);
 	else
      reviews(baseUrl + 'reviews/slug/' + productSlug + '/'+ sort + '/' + order + '/' + stars_filter);


  });
    
    
    
  
  });
  
} // func

  
  
  
//
function reviews(url) {
  console.log("URL " +url) // DEBUG
  container = jQuery('#lbm-reviews');
  container.html('');
  
  jQuery.get(url, function(data) { 

    var reviews_stars = 0;
    var reviews_count = 0;
    
   // console.log("Reviews count: " + );
    // Pagination 
    
    var pages='';
    
    for (i=1; i<=data.last_page; i++) {
      if (i==data.current_page) active=' active'; else active='';
      pages += '<a href="#" class="review-page-link'+active+'" data-page="'+i+'">'+i+'</a> ';
    }
    
    jQuery('#reviews-pagination').html(pages);
    
    
    // Reviews - Show - Default view
    
    jQuery(data.data).each(function(index, item) {
     // console.log("URL " +url) // DEBUG
      reviews_count++;
      reviews_stars += item.stars;
      stars = '';
      for (i = 0; i < item.stars; i++) { 
        stars += '<i class="star"></i>';
      }
      
      photos_html = '';
      photos = item.photos;
      
      jQuery(photos).each(function(index, photo) {
      	photos_html += '<a class="review-image fancybox" href="' + baseUrl + 'storage/big/' + photo.filename + '"><img src="' + baseUrl + 'storage/small/' + photo.filename + '" alt="" /></a>';
      });
      
 
      helpful=item.helpful;
      helpful_txt='';
      if (helpful>0)
      	helpful_txt = inWords(helpful)+' person found this helpful.';
      if (helpful>1)
      	helpful_txt = inWords(helpful)+' persons found this helpful.';
      
      
      // Comments
      comments = '';
  	  comment_form = '';

      if (item.comments.length) {
      	comments_txt = '<button class="review-comments-view" data-review-id="'+ item.id + '">' + item.comments.length + ' comment';
        if (item.comments.length>1) comments_txt += 's';
        comments_txt += '</button>';
       
       comments += '<button class="review-comment-add" data-review-id="'+ item.id + '">Comment</button><div class="review-comment-form-container"></div>';

       jQuery(item.comments).each(function(c_index, c_item) {

         	comments += '<div class="comment">';
        	comments += '<div class="comment-author"><strong>' + c_item.name + '</strong> on ' + c_item.created_at + '</div>';
            comments += '<div class="comment-comment">' + c_item.comment + '</div>';
			comments += '</div>';

       });
       
        
      }
      else {
      	comments_txt = '<button class="review-comment-add" data-review-id="'+ item.id + '">Comment</button>';
        comment_form = '<div class="review-comment-form-container"></div>';
      }
      
      container.append(
      
        '<div class="review review-' + item.id + '">' + 
        stars +
        '<h3 class="review-title">' + item.title + '</h3>' +
        '<span class="review-meta"><strong>'+ item.name +'</strong> on <strong>' + item.created_at + '</strong></span>' +
        '<div class="review-review">' + item.review + '<br/><br/>' + photos_html + '</div>' +
        '<div class="review-links">' + comments_txt + ' | <div class="helpful">' + helpful_txt.capitalize()+' Was this review helpful to you? <a href="#" class="review-helpful" data-review-id="'+ item.id + '">Yes</a> ' +
        '<a href="#" class="review-nothelpful" data-review-id="'+ item.id + '">No</a></div></div>' +
        comment_form +
        '<div class="comments">' + comments + '</div>' +
        '</div>'
        
      );
	});
    
    if (reviews_count==0) {
      container.html("There are no reviews matching the criteria.<br/><br/>");
      container.removeClass('loading');
    }
	else 
      container.addClass('loading');

    
	var rating = Math.round(reviews_stars/reviews_count);
    
    //console.log("Reviews count: " + reviews_count);
    
    stars = '';
    
    for (i = 0; i < rating; i++) { 
      stars += '<i class="star"></i>';
    }
    
 //   container.prepend( stars + ' Based on ' + reviews_count + ' reviews.');
    

  // Pagination handling
    
      jQuery('.review-page-link').on('click', function(event) { 
   		event.preventDefault();
        page = jQuery (this).attr('data-page');
        
        jQuery('html, body').animate({
        	scrollTop: jQuery("#customer-reviews").offset().top
    	}, 'fast');
        
        jQuery('.review-page-link').removeClass('active');
        jQuery(this).addClass('active');

        
        if (searchQuery.length>0)
          reviews(baseUrl + 'reviews/slug/' + productSlug +'/' + sort + '/' + order + '/' + stars_filter + '/' + searchQuery + '?page='+page);
		else
          reviews(baseUrl + 'reviews/slug/' + productSlug +'/' + sort + '/' + order + '/' + stars_filter + '?page='+page);
      });
    
    
  // Helpful handling
  
  jQuery('.review-helpful').on('click', function(event) { 
   event.preventDefault();
    var id = jQuery(this).attr('data-review-id');
    jQuery.get(baseUrl + 'reviews/helpful/' + id + '/helpful', function(data) {
      jQuery('.review-'+id+' .helpful').html('Thank you for your feedback.');
    });
    
  });
   
  jQuery('.review-nothelpful').on('click', function(event) { 
   event.preventDefault();
    var id = jQuery(this).attr('data-review-id');
    jQuery.get(baseUrl + 'reviews/helpful/' + id + '/nothelpful', function(data) {
      jQuery('.review-'+id+' .helpful').html('Thank you for your feedback.');
    });
    
  });
   
  
  // Comments - View
    jQuery('.review-comments-view').on('click', function(e) {
    
      var review_id = jQuery(this).attr('data-review-id');
      jQuery(this).attr("disabled","disabled");
      jQuery('.review-'+ review_id + ' .comments').show();
      
    
    });
    
  // Comment - Form
  
  jQuery('.review-comment-add').on('click', function(e) {
   event.preventDefault();
    
    var review_id = jQuery(this).attr('data-review-id');
    
    jQuery(this).attr("disabled","disabled");
    jQuery('.review-'+ review_id + ' .review-comment-form-container').html(
		'<form class="review-comment-form review-form" method="post">' +
        '<p><label>Name</label><input type="text" name="name" class="field" placeholder="Your name"></p>' +
      	'<p><input type="hidden" name="review_id" value="'+review_id+'" /></p>' +
        '<p><label>Your comment</label><textarea name="comment" class="field" placeholder="Your comment"></textarea></p>' +
      	'<p><input type="submit" value="Add"></p>' +
      	'</form>'
    );
    
      jQuery(".review-form .field").on('focus', function() {
        jQuery(this).removeClass('error');
      })
    
    
    
    // Comment - Add 
    
    jQuery(".review .review-comment-form").on('submit', function( event ) {
      
      event.preventDefault();
      
	  var error;
    
    if (jQuery(this).find('input[name="name"]').val().length<1) {
      	jQuery(this).find('input[name="name"]').addClass('error');
      	error=1;
    }
      
    if (jQuery(this).find('textarea[name="comment"]').val().length<1) {
      	jQuery(this).find('textarea[name="comment"]').addClass('error');
      	error=1;
    }
      
      if(!error) {
      
    jQuery.post(baseUrl + 'comments', jQuery(this).serialize())
    .done(function(e) {    
      console.log('Success!');
      jQuery('.review-'+review_id+' .review-comment-form-container').html("Comment sent!");
    })
    .fail(function(e) {
     console.log( "Error" );
    });
       
  	}
  		// console.log(jQuery(this).serialize())
  	}); // Comment - Add - END 
  
   
                                              
  }); // Comment - Form - END
  

    

    
    
    
  });
  
    
  
} //function reviews()

             
  
  
  
  jQuery(".review-form .field").on('focus', function() {
  	jQuery(this).removeClass('error');
  })
             
  
  // Add review
  jQuery("#review-form").submit(function( event ) {
    
    jQuery('#review-form input[type="submit"]').prop('disabled', true);
    
    var error;
    
    if (jQuery('.review-form input[name="title"]').val().length<1) {
      	jQuery('.review-form input[name="title"]').addClass('error');
      	error=1;
    }
    
        if (jQuery('.review-form input[name="name"]').val().length<1) {
      	jQuery('.review-form input[name="name"]').addClass('error');
      	error=1;
    }
    
    if (jQuery('.review-form input[name="email"]').val().length<1) {
      	jQuery('.review-form input[name="email"]').addClass('error');
      	error=1;
    }
    
    if (jQuery('.review-form textarea').val().length<1) {
      	jQuery('.review-form textarea').addClass('error');
      	error=1;
    }
    
    if (! jQuery('input[name="stars"]').is(":checked")) {
        alert ('Please rate the product clicking stars.');
      	error=1;
    }
    
    if (error) {
    	jQuery('#review-form input[type="submit"]').prop('disabled', false);
    }
    
    if (!error) {
      
	var form = jQuery(this);
    var formdata = false;
    if (window.FormData){
        formdata = new FormData(form[0]);
    }

    jQuery.ajax({
        url: baseUrl + 'reviews',
        type: 'POST',
        data: formdata ? formdata : form.serialize(),
  		cache: false,
        contentType: false,
        processData: false,
        success: function(data, textStatus, jqXHR){
          jQuery("#review-form").html('Review sent!');
          console.log ('success');
        },
        error: function (xhr, desc, err) {
		  console.log('error')
        }
    })
    .always(function() {
      
    });    
    
    } // if !error
    
      
  event.preventDefault();
  });
  
    
 
  
});
